
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 762.93 731.41"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M24.49 243.34l201.34-20.85A27.26 27.26 0 00247 208.42l105.74-194.2a27.26 27.26 0 0147.53-.63q55.21 95.35 110.42 190.68l19.68 13.31 209.18 30.28c22.34 3.23 31.3 30.66 15.17 46.45q-76.45 74.89-152.9 149.79a27.24 27.24 0 00-7.9 23.4l32.83 225a27.26 27.26 0 01-38.13 28.81l-203.51-91.23-24.05.86-180.78 97.17c-19.21 10.32-42.17-5-40-26.67q11-112.22 22-224.41l-6.73-20.73Q81.22 372.4 6.89 288.54c-14.71-16.61-4.48-42.91 17.6-45.2z","fill":"#3361cc","data-name":"Calque 1"}})])])
          )
        }
      }
    